<template>
  <div class="emat-info" :class="device">
    <div class="welcome" :class="device">
      <EmatClose @click="$emit('next', {data: null})" />
      <EmatBlock :name="$t('Welcome.welcome_to')" />
      <emat-block-item style="text-align: left;"
                       :style="device === 'mobile' ? 'padding: 15px 20px 15px 32px' : 'padding: 21px 18px 28px 18px'">
        <p class="text">
          {{ $t('Welcome.intro_text') }}
          <br><br>
          {{ $t('Welcome.specifications_known') }}<br>
          <span @click="$emit('next', {data: null})" class="link">{{ $t('Welcome.continue_without_selecting_car')
            }}</span>
        </p>
      </emat-block-item>
      <div class="search-container">
        <div class="half left">
          <div class="title">{{ $t('Welcome.search_licenseplate') }}</div>
          <div class="search-input">
            <input
              type="text"
              placeholder="12-XX-34"
              v-model="licensePlate"
            />
            <CloseSvg v-if="licensePlate" class="close-svg" @click="resetLicensePLate"/>
          </div>
          <div class="search-result" v-if="loading || Object.keys(searchResult).length">
            <div v-if="loading">
              <EmatLoader :loading="loading" :global="false" />
            </div>

            <div v-else>
              <div v-if="searchResult.brand_name === null && licensePlate !== ''">
                <p>{{ $t('Welcome.could_not_find_licenseplate') }}</p>
              </div>

              <div
                v-else-if="(searchResult.brand_name !== null && searchResult.model  === null) || (searchResult.model && searchResult.model !==  null && searchResult.model.configuration === null)">
                <p style="margin: 0;">
                  <span class="sub-title">{{ $t('Welcome.found_car') }}</span><br>
                  <span class="text">{{ searchResult.brand_name }} {{ searchResult.model_name }}</span>
                </p>
                <p>{{ $t('Welcome.no_configuration_ready') }}</p>
              </div>

              <div
                v-else-if="searchResult.hasOwnProperty('brand_name') && searchResult.brand_name !== null && searchResult.model  !== null">
                <p style="margin: 0;">
                  <span class="sub-title">{{ $t('Welcome.found_car') }}</span><br>
                  <span class="text">{{ searchResult.brand.name }} {{ searchResult.model.name }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="half right">
          <div class="title">{{ $t('Welcome.search_manually') }}</div>

          <EmatSelect
            :options="carBrands"
            :value="selectedBrand"
            name="car-brands"
            @change="selectBrand"
            :disabled="!canSelectBrand"
            initial-label="Selecteer merk"
            style="margin: 0;"
          />

          <EmatSelect
            :options="carModels"
            :value="selectedModel"
            name="brand-models"
            @change="selectModel"
            :disabled="!canSelectModel || !selectedBrand"
            initial-label="Selecteer type"
            style="margin-top: 14px;"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          class="btn-green"
          :disabled="!canContinue"
          @click="submit">
          <span class="wrapper">
            <span class="next" v-if="!canContinue">{{ $t('Welcome.select_car_first') }}</span>
            <span class="next" v-else>{{ $t('Welcome.go_on_with') }}</span>
            <span v-if="searchResult.brand_name && searchResult.model_name">
              {{ this.searchResult.brand_name + ' ' + this.searchResult.model_name }}
            </span>
            <span v-else-if="currentBrand && currentCarModel">
              {{ this.currentBrand.name + ' ' + this.currentCarModel.name }}
            </span>
          </span>
        </button>
      </div>
      <div class="sub-link">
        <span @click="$emit('next', {data: null})" class="link">{{ $t('Welcome.continue_without_car') }}</span>
      </div>
    </div>
    <div class="emat-info-backdrop" @click="$emit('next', {data: null})">

    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { searchCar } from '@/services/api';
import EmatBlock from 'Components/Layout/Block';
import EmatBlockItem from 'Components/Layout/BlockItem';
import EmatSelect from 'Components/Inputs/Select';
import EmatLoader from 'Components/General/Loader';
import EmatPopup from 'Components/Layout/Popup';
import EmatClose from '@/components/ui/EmatClose';
import ButtonPrimary from 'Components/Buttons/Primary/ButtonPrimary';
import CloseSvg from '../../assets/images/icons/close.svg?inline';

export default {
  name: 'Welcome',

  data() {
    return {
      selectedBrand: null,
      selectedModel: null,
      loading: false,
      debouncePlate: null,
    };
  },

  components: {
    ButtonPrimary,
    EmatClose,
    EmatBlock,
    EmatBlockItem,
    EmatSelect,
    EmatLoader,
    EmatPopup,
    CloseSvg,
  },

  watch: {
    licensePlate: {
      deep: true,
      handler() {
        this.checkValidInput();
      },
    },
  },

  methods: {
    submit() {
      if (this.searchResult.brand_name && this.searchResult.model_name) {
        this.submitSearchResult();
      } else {
        this.$store.dispatch('build/changeBrand', this.selectedBrand);
        this.$store.dispatch('build/changeCarModel', this.selectedModel);
        this.$store.dispatch('build/changeConfiguration', this.currentCarModel.configuration);
        this.$store.dispatch('build/setMethodByName', '5m');
        this.$emit('next', { carBrand: this.selectedBrand, carModel: this.selectedModel });
      }
    },
    submitSearchResult() {
      this.$store.dispatch('build/changeBrand', this.searchResult.brand.id);
      this.$store.dispatch('build/changeCarModel', this.searchResult.model.id);
      this.$store.dispatch('build/changeConfiguration', this.searchResult.model.configuration);
      this.$store.dispatch('build/setMethodByName', '5m');
      this.$emit('next', { carBrand: this.searchResult.brand.id, carModel: this.searchResult.model.id });
    },
    selectBrand(val) {
      this.selectedBrand = val;
      this.selectedModel = this.carModels[0].id;
    },
    selectModel(val) {
      this.selectedModel = val;
    },
    checkValidInput() {
      // // Regex for checking license plate input
      let regex = /([a-zA-Z]{1,3}[0-9]{1,3})|(\w{1,2}-\w{1,2}-\w{1,2})|([0-9]{1,3}-[a-zA-Z]{1,3}-[0-9]{1})|([0-9]{1}-[a-zA-Z]{3}-[0-9]{2})|([a-zA-Z]{1,2}-[0-9]{3}-[a-zA-Z]{1,2})/;

      if (regex.test(this.licensePlate) === true && this.trimString(this.licensePlate).length === 6) {
        this.searchAvailableCars();
      } else {
        this.$store.commit('searchResult', { brand_name: null });
      }
    },
    searchAvailableCars() {
      this.loading = true;
      let license = this.trimString(this.licensePlate);

      const postData = {
        license: license,
      };

      searchCar(this.environmentId, postData)
        .then((response) => {
          this.$store.commit('searchResult', response.data);
          this.loading = false;
        })
        .catch((error) => {
          this.$store.commit('searchResult', { brand_name: null });
          this.loading = false;
        });
    },
    trimString(str) {
      return str = str.replace(/-/g, '');
    },
    resetLicensePLate() {
      this.licensePlate = '';
      this.$store.commit('searchResult', { brand_name: null });
    }
  },
  computed: {
    ...mapState([
      'environmentId',
    ]),
    ...mapState('brands', {
      brands: state => state.all,
    }),
    ...mapGetters({
      searchResult: 'getSearchResult',
      brandsById: 'brands/mappedById',
      device: 'getDevice',
    }),
    licensePlate: {
      get() {
        return this.$store.getters['build/getLicensePlate'];
      },
      set(value) {
        this.$store.commit('build/setLicensePlate', value);
      },
    },
    canSelectBrand() {
      return this.licensePlate === '';
    },
    canSelectModel() {
      return this.licensePlate === '';
    },
    canContinue() {
      return (this.selectedModel && this.selectedBrand) ||
        (this.searchResult.brand_name && this.searchResult.model_name);
    },
    currentBrand() {
      return this.brandsById[this.selectedBrand];
    },
    currentCarModel() {
      return this.brandsById[this.selectedBrand].car_models.find((m) => m.id === this.selectedModel);
    },
    carBrands() {
      return this.brands
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((c) => {
          return {
            id: c.id,
            label: c.name,
            value: c.id,
          };
        });
    },
    carModels() {
      if (!this.currentBrand) {
        return [];
      }

      return this.currentBrand.car_models
        .sort((a, b) => {
          // First check on name
          const name = a.name.localeCompare(b.name);
          if (name !== 0) {
            return name;
          }

          // Version
          if (a.version) {
            const version = a.version.localeCompare(b.version);

            if (version !== 0) return version;
          }

          return 0;
        })
        .map((c) => {
          let label = c.name;

          if (c.version) {
            label += ' ' + c.version;
          }

          label += `<br><small><i>${c.available_from} - ${c.available_to ||
          this.$t('global.word.contemporaneity')}</i></small>`;

          return {
            id: c.id,
            label,
            value: c.id,
          };
        });
    },
  },

  created() {
    this.selectedBrand = this.$store.getters['build/getBrand'] ? this.$store.getters['build/getBrand'].id : null;
    this.selectedModel = this.$store.getters['build/getModel'] ? this.$store.getters['build/getModel'].id : null;
  },
};
</script>

<style scoped lang="scss">
.welcome {
  width: 590px;
  max-width: calc(100vw - 30px);
  position: relative;
  z-index: 12;

  &.mobile {
    position: absolute;
  }

  .emat-block {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .emat-block-item {
    background-color: $white;
  }

  .sub-title {
    color: $primary;
    font-size: 14px;
    font-family: $font-black;
  }

  .modal-footer {
    background-color: $white;
    padding: 14px 0;
    display: flex;
    justify-content: center;
    border-bottom-right-radius: $border-radius;
    border-bottom-left-radius: $border-radius;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.05);
    white-space: nowrap;

    @media only screen and (max-width: 576px) {
      padding: 0;

      button {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        white-space: break-spaces;
        width: 100%;
        max-width: 100%;
      }
    }

    .next {
      padding-right: 4px;
      white-space: nowrap;
    }
  }

  .text {
    margin: 0;
    display: block;
    max-width: 540px;
    font-family: $font;
    font-size: 14px;
    color: #000;

    .link {
      color: $primary-lighter;
      font-family: $font-black;
      transition: all ease 0.2s;

      &:hover {
        color: $primary;
        cursor: pointer;
      }
    }
  }

  .search-container {
    background-color: $highlight;
    padding: 25px 18px 32px 18px;
    display: flex;

    .half {
      width: 50%;
      position: relative;

      &.left {
        border-right: 1px solid $primary-lighter;
        min-height: 140px;
        max-height: 180px;

        .search-input {
          background-image: url('../../assets/images/kenteken.svg');
          background-repeat: no-repeat;
          height: 44px;
          position: relative;
          margin-bottom: 14px;
          display: flex;
          align-items: center;

          .close-svg {
            margin-left: 8px;
            width: 24px;
            height: 24px;
            cursor: pointer;
            transition: all ease 0.2s;

            &:hover {
              transform: scale(1.1);
            }
          }

          input {
            font-family: Kenteken, sans-serif;
            height: 43px;
            width: 100%;
            max-width: 199px;
            padding: 0;
            box-sizing: border-box;
            overflow: hidden;
            //margin-top: 2px;
            border-radius: 10px;
            background-color: transparent;
            font-size: 26px;
            text-align: center;
            padding-left: 17px;
            border: 2px solid transparent;

            &::placeholder {
              color: transparentize(black, 0.8);
              text-align: center;
            }

            &:focus {
              outline: none;
            }
          }
        }

        .search-result {
          font-family: $font;
          display: flex;
          flex-direction: column;
          font-size: 14px;

          .result {
            line-height: 1.4;
            font-size: 14px;
          }
        }
      }

      &.right {
        padding-left: 16px;

        form {
          display: flex;
          flex-direction: column;
        }

        button {
          left: 17px;
        }
      }
    }

    .title {
      font-size: 20px;
      color: #196CAE;
      font-family: $font-heading-bold;
      padding-bottom: 10px;
    }
  }
}

.emat-info {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.emat-info-backdrop {
  background-color: rgba(0, 0, 0, .7);
  position: fixed;
  z-index: 9;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.sub-link {
  display: flex;
  justify-content: center;

  .link {
    font-family: $font;
    color: $white;
    display: inline-block;
    text-align: center;
    padding-top: 14px;
    transition: all ease 0.2s;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      color: #196CAE;
    }
  }
}

.emat-close {
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 1;
  left: 88%;
  top: 72px;
}

.welcome.mobile {
  max-height: 100%;
  padding-bottom: 50px;

  .search-container {
    display: block;

    .search-input {
      width: 225px;
      margin-right: auto;
      position: relative;
    }

    .half {
      width: 100%;

      button {
        width: 100%;
      }

      &.left {
        border: none;
      }

      &.right {
        padding: 0;

        button {
          left: 0;
        }
      }
    }
  }
}

</style>
